import React from "react";
import {toDate} from "date-fns";
import {DATE_FORMAT} from "@reside/ui";

import {
  AdmissionId,
  CellFooter,
  CellIdentityBlock,
  CellLastUpdatePrefix,
  CellLastUpdateRow,
  CellLastUpdateTime,
  CellMetaProgressSlot,
  CellMetaRow,
  CellResidentNameLink,
  DashboardCell,
  Left,
  Right,
} from "../../../../dashboard-cell";
import {WorkflowRibbon} from "../../../../dashboard-cell/WorkflowRibbon";
import {RelativeDateTime} from "../../../../relative-date-time";
import {ProgressBar} from "../../progress-bar";
import {AdmissionFromSearch} from "../../../../../services/AdmissionsService";
import {AdmissionChecklist} from "../admission-checklist";
import {FlagPopover} from "../../flag-popover";
import {getAdmissionResidentName, getResidentTestId} from "../../../helper";
import {StartResidentExperienceFooterButton} from "./ResidentLoginDropdownItem";
import {InProgressSplitButton} from "./InProgressSplitButton";
import {StarAdmissionIcon} from "../../../../star-icon/StarAdmissionIcon";
import {getAdmissionViewHref} from "../../../../dashboard-cell/admissionRoutes";

type Props = Readonly<{
  admission: AdmissionFromSearch;
}>;

export const AdmissionInProgressCell = ({admission}: Props) => {
  const updatedAt = toDate(admission.updated * 1000);

  return (
    <DashboardCell admissionHref={getAdmissionViewHref(admission.id)}>
      <WorkflowRibbon
        workflowType={admission.workflowType}
        star={
          <StarAdmissionIcon
            admissionId={admission.id}
            isStarred={admission.starred}
          />
        }
        actions={<InProgressSplitButton admission={admission} />}
      />
      <CellIdentityBlock>
        <CellResidentNameLink
          name={getAdmissionResidentName(admission)}
          residentId={admission.residentId}
          data-test-id={getResidentTestId(admission, "editProfile")}
        />
        <AdmissionId code={admission.code} />
      </CellIdentityBlock>
      <CellMetaRow>
        <CellMetaProgressSlot>
          <ProgressBar progress={admission.completionPercentage} flushTop />
        </CellMetaProgressSlot>
      </CellMetaRow>
      <AdmissionChecklist admission={admission} />
      <CellFooter>
        <Left>
          <CellLastUpdateRow>
            <CellLastUpdatePrefix>Last update:</CellLastUpdatePrefix>
            <CellLastUpdateTime>
              <RelativeDateTime
                dateTime={updatedAt}
                dateFormat={DATE_FORMAT.DAY_IN_MONTH}
              />
            </CellLastUpdateTime>
          </CellLastUpdateRow>
        </Left>
        <Right>
          {admission.flags.length > 0 ? (
            <FlagPopover
              flagCount={admission.flags.length}
              admissionId={admission.id}
            />
          ) : null}
          <StartResidentExperienceFooterButton admission={admission} />
        </Right>
      </CellFooter>
    </DashboardCell>
  );
};
